export const letsgoPath = "/letsgo";
export const thanksResponsesPath = "/thanks";
export const loginRedirectPath = "/forms";
export const IntroTitle = "Please read carefully";
export const ExitFullScreenButton = "Exit Full Screen";

export type ErrorType = {
	status: number;
	body:
		| {
				error: {
					message: string;
				};
		  }
		| Array<{
				type: string;
				errors: {
					name: string;
					message: string;
				};
		  }>;
};
